import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useRouter } from '@tanstack/react-router'

import { sessionBus } from '@/lib/api/session'

/**
 * Turns "the session ended" (a 401 anywhere, or session.ended on a stream) into the sign-in screen
 * with a way back. Screens holding unsent work intercept the bus first (lib/api/session.ts).
 */
export function SessionBridge() {
  const router = useRouter()
  const queryClient = useQueryClient()
  useEffect(
    () =>
      sessionBus.subscribe((reason) => {
        const href = router.state.location.href
        if (router.state.location.pathname === '/login') return
        void router
          .navigate({ to: '/login', search: { reason, redirect: href }, replace: true })
          .then(() => queryClient.clear())
      }),
    [router, queryClient],
  )
  return null
}
